import { reloadUserProfile } from '../UserProfile/actions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

let lastExecution: number | null = null;

export function useProfileSync(delay: number = 300000) {
  const dispatch = useDispatch();

  useEffect(() => {
    const now = Date.now();
    if (lastExecution === null || now - lastExecution >= delay) {
      dispatch(reloadUserProfile());
      lastExecution = now;
    }
  }, []);
}



// WEBPACK FOOTER //
// ./src/containers/App/useProfileSync.ts